import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Translate } from 'react-localize-redux';
import classNames from 'classnames';
import Icon, { IconSizes } from '../../foundations/Icon';
import { isFieldSelectionCleared, reportTypes } from '../../../utils/reports';
import { clearFieldsBySectionSelection, clearFieldSelection, setActionType } from '../../../actions/reports';
import css from './ClearFieldsButton.css';
import { reportDataSelectors } from '../../../selectors/reports';
import { isShelfReporting } from '../../../selectors/user';

export const CLEAR_MIXPANEL_EVENT = 'Clear Report Fields Clicked';

const shouldHideButton = (reportType, selected, state) => {
    return (
        reportType === reportTypes.mainReport && !(selected.showFieldsSelection && !isShelfReporting(state, reportType))
    );
};

const ClearFieldsButton = ({ reportType, section = null, items = null }) => {
    const dispatch = useDispatch();

    const reportState = useSelector(state => reportDataSelectors[reportType](state));
    const { selectedFields, filters: selectedFilters } = useSelector(state => state[reportType]);
    const hideButton = useSelector(state => shouldHideButton(reportType, reportState, state));

    if (hideButton) return null;

    const disabled =
        reportState.disableReportState ||
        (items
            ? !items.some(item => !!selectedFields[item.configItem.type]?.length)
            : isFieldSelectionCleared(reportType, selectedFields, selectedFilters));

    const handleClick = e => {
        if (e && e.stopPropagation) e.stopPropagation();

        const eventData = { report_type: reportType };
        if (section) {
            eventData.section = section;
        }
        window.mixpanel.track(CLEAR_MIXPANEL_EVENT, eventData);

        const clearAction = items ? clearFieldsBySectionSelection(items) : clearFieldSelection();
        dispatch(setActionType(clearAction, reportType));
    };

    const clearLabelId = section ? 'STATIC.BUTTONS.CLEAR_SECTION' : 'STATIC.BUTTONS.CLEAR_FIELDS_SELECTION';

    return (
        <div onClick={handleClick} className={classNames(css.container, { [css.disabled]: disabled })}>
            <Icon name="eraser" size={IconSizes.MEDIUM} disabled={disabled} className={css.icon} />
            <Translate id={clearLabelId} />
        </div>
    );
};

ClearFieldsButton.propTypes = {
    reportType: PropTypes.string.isRequired,
    section: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            configItem: PropTypes.shape({
                type: PropTypes.string.isRequired,
            }).isRequired,
        })
    ),
};

export default ClearFieldsButton;
